export default __webpack_public_path__ + "static/media/login-image.da6632a3.jpg";